import { FC } from 'react';
import { Button } from '.';
import { RefactoredButtonProps } from './button-props';
import { LoadingDots } from '../Loading';
import { useAsyncClick } from '../hooks/useAsyncClick';

const RemoveButton: FC<RefactoredButtonProps & { [key: string]: any }> = ({
  title,
  onClick,
  onClickAsync,
  enabled = true,
  isWorking = false,
  preventDoubleClick = true,
  ...otherProps
}) => {
  const { run, isRunning } = useAsyncClick(
    async (e?: any) => {
      if (onClickAsync) await onClickAsync(e);
    },
    { debounceMs: 500 }
  );
  const working = isWorking || (preventDoubleClick && isRunning);
  const canClick = enabled && !working;
  return (
    <Button
      size="xs"
      color={canClick ? 'error' : 'disabled'}
      onClick={(e) => (onClickAsync ? run(e) : onClick && onClick(e))}
      disabled={!canClick}
      {...otherProps}
    >
      {working ? <LoadingDots color="white" /> : title}
    </Button>
  );
};

export default RemoveButton;
